import React from 'react';
import { Button } from '@chakra-ui/react';
import { House, X } from '@phosphor-icons/react';

const AdsFilterButton = ({ refetch, dispatch, state }) => {
  const handleShowAdsIsActive = async () => {
    // await refetch({
    //   where: {
    //     ...state.searchValues,
    //     acceptEmails: state.adsIsActive ? undefined : true,
    //   },
    // });
    dispatch({ type: 'SET_ADS_IS_ACTIVE', value: state.adsIsActive ? false : true });
  };
  const handleShowAdsIsInactive = async () => {
    // await refetch({
    //   where: {
    //     ...state.searchValues,
    //     acceptEmails: state.adsIsInactive ? undefined : false,
    //   },
    // });
    dispatch({ type: 'SET_ADS_IS_INACTIVE', value: state.adsIsInactive ? false : true });
  };

  return (
    <>
      <Button size="sm" mr="2" onClick={handleShowAdsIsActive} colorScheme={state.adsIsActive ? 'blue' : undefined}>
        Werbung erwünscht
      </Button>
      <Button size="sm" mr="2" onClick={handleShowAdsIsInactive} colorScheme={state.adsIsInactive ? 'blue' : undefined}>
        Werbung unerwünscht
      </Button>
    </>
  );
};

export default AdsFilterButton;
